// extracted by mini-css-extract-plugin
export default {"tudo":"home_tudo__KH7oZ","copy":"home_copy__MaIJi"};